import fetch from "cross-fetch";
import {CMS_API_URL} from "../../config";
import * as ActionCreators from "./creators";
import { pushNotification } from "../ui_notifications/creators";

export function fetchAgreements() {
  return function(dispatch, getState) {     
    dispatch(ActionCreators.fetchingAgreements());
    let url = `${CMS_API_URL}/circleagreements`;
    // let request_options = {
    //   headers: { "Content-Type": "application/json"}
    // }
    // if(getState().iam.accessToken){
    //   request_options.headers["Authorization"] = `Bearer ${getState().iam.accessToken}`;
    // }

    return fetch(url)
      .then(
        response => response.json(),
        error => {
          dispatch(ActionCreators.errorFetchingAgreements(error));
        }
      )
      .then(response => {   
          if('message' in response && response.message === "Internal Server Error"){
            dispatch(pushNotification("errors.expenses.fetch", "error"));            
            dispatch(ActionCreators.errorFetchingAgreements(response.message));
          }else{
            dispatch(ActionCreators.fetchedAgreements(response));
          }        
      });
  };
}